import { render, staticRenderFns } from "./qmodel.vue?vue&type=template&id=2606457c&scoped=true"
import script from "./qmodel.vue?vue&type=script&lang=js"
export * from "./qmodel.vue?vue&type=script&lang=js"
import style0 from "./qmodel.vue?vue&type=style&index=0&id=2606457c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606457c",
  null
  
)

export default component.exports